// Extracted from the `list.campaignBulk` namespace of en.ts so the (over-length) main
// translation file stays within the architecture-gate line ratchet. Referenced back under its
// original `list.campaignBulk` key in en.ts.
export const enListCampaignBulk = {
	active: "Active",
	partiallyActive: "Partially active",
	paused: "Paused",
	pauseAll: "Pause all",
	activateAll: "Activate all",
	statusChangeFailed_one: "{{count}} campaign could not be updated. Nothing changed for it.",
	statusChangeFailed_other: "{{count}} campaigns could not be updated. Nothing changed for them.",
};
